module.exports = __webpack_public_path__ + "static/2-b8988ddd13b8417dd26344d19cf3cbd4.jpeg";